var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#009639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2071 6.29289C20.5977 6.68342 20.5977 7.31658 20.2071 7.70711L10.2071 17.7071C10.006 17.9082 9.72874 18.0142 9.44474 17.9985C9.16073 17.9827 8.89686 17.8468 8.71917 17.6247L4.71917 12.6247C4.37416 12.1934 4.44408 11.5641 4.87534 11.2191C5.3066 10.8741 5.9359 10.944 6.28091 11.3753L9.58296 15.5029L18.7929 6.29289C19.1835 5.90237 19.8166 5.90237 20.2071 6.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.84e14da703f7ed2abd706de994805d87.svg";
export { ForwardRef as ReactComponent };